import { Box } from "@mui/material";
import type { JSX } from "react";

import type { SalesOrgLeadDetail } from "@xop/dashboard-shared";

import {
  AngleCard,
  EvidenceCard,
  FallbackReasoningCard,
  OutreachCard,
  WhyNowCard,
} from "./BodyCards.js";
import { ContactCard } from "./ContactCard.js";

/* ── Body composition (sections in priority order) ────────────── */

export function Body({ lead }: { lead: SalesOrgLeadDetail }): JSX.Element {
  const brief = lead.briefs?.[0];

  // 50/50 split — the "why" (research / context) on the left, the
  // "what to do" (outreach / contacts) on the right. Stacks to one column
  // below lg (and on the printed copy, which is < lg wide).
  return (
    <Box sx={{ display: "grid", alignItems: "start", gap: 2.5, gridTemplateColumns: { lg: "repeat(2, 1fr)" } }}>
      {/* Left — why this lead, now */}
      <Box sx={{ display: "grid", alignContent: "start", gap: 2.5 }}>
        {brief?.xop_angle ? <AngleCard angle={brief.xop_angle} /> : null}
        {brief?.why_now_markdown ? (
          <WhyNowCard brief={brief} />
        ) : lead.agent_full_reasoning ? (
          <FallbackReasoningCard text={lead.agent_full_reasoning} />
        ) : null}
        <EvidenceCard
          signals={lead.signals}
          signalKinds={lead.signal_kinds}
          pinned={brief?.evidence ?? []}
        />
      </Box>

      {/* Right — how to reach them */}
      <Box sx={{ display: "grid", alignContent: "start", gap: 2.5 }}>
        {brief?.suggested_first_message ? (
          <OutreachCard message={brief.suggested_first_message} />
        ) : null}
        <ContactCard lead={lead} />
      </Box>
    </Box>
  );
}
